import { SliderInput } from '@naker/design/Inputs/slider';
import { ImageAssetButton } from '@naker/design/Pickers/assetPicker';
import { InputGroupSwitch } from '@naker/design/Layers/actionPanel';
import { Particle, particleInterface } from '../viewer/particle';
import { Environment, environmentInterface } from '../viewer/environment';
import { movementSettingsClass } from './movementSettings';
import { BackUndo } from './service/undo';

/*
  +------------------------------------------------------------------------+
  | MOVEMENTS MANAGER                                                      |
  +------------------------------------------------------------------------+
*/

export class AnimationSettings extends InputGroupSwitch {

    particle: Particle;
    environment: Environment;
    AnimationSettings: movementSettingsClass;

    constructor(undo: BackUndo, particle: Particle, environment: Environment) {
        super('Movements', undo);

        this.particle = particle;
        this.environment = environment;
        this.AnimationSettings = new movementSettingsClass(undo, this.el, particle);
        this.AnimationSettings.onChange = () => {
            // If life was infinite, we reduce it to show movement
            if (this.particle.life > 1000) {
                this.particle.checkParticlePower(0.2);
                this.particle.setPower(0.2);
                this.powerInput.setValue(0.2);
            }
        }

        this.addGeometryInput();
        this.checkInput(particle.getOptions(), environment.getOptions());

        undo.on("change", (change) => {
            if (change.particle) this.checkParticleInput(change.particle);
            if (change.environment) this.checkEnvironmentInput(change.environment);
        });
    }

    textureInput: ImageAssetButton;
    numberInput: SliderInput;
    sizeEndInput: SliderInput;
    powerInput: SliderInput;
    sensitivityInput: SliderInput;

    addGeometryInput() {
        this.powerInput = this.addSlider('Speed', { value: 1, min: 0, max: 0.5, step: 0.001, curve: 'logarithmic' }, (value) => {
            this.particle.checkParticlePower(value);
            this.particle.setPower(value);
            // If no speed, it can't be any movement
            if (value == 0) this.AnimationSettings.eraseDirections();
        });

        this.sensitivityInput = this.addSlider('Camera sensitivity', { value: 1, min: 0, max: 1, step: 0.01 }, (value) => {
            this.environment.setSensitivity(value);
        });
    }

    resetInput(particleoptions: particleInterface, environmentOptions: environmentInterface) {
        this.powerInput.setValue(particleoptions.power);
        this.sensitivityInput.setValue(environmentOptions.sensitivity);
        this.AnimationSettings.resetInput(particleoptions);
    }

    checkInput(particleoptions: particleInterface, environmentOptions: environmentInterface) {
        this.checkParticleInput(particleoptions);
        this.checkEnvironmentInput(environmentOptions);
    }

    checkParticleInput(particleoptions: particleInterface) {
        if (particleoptions.power !== undefined) this.powerInput.setValue(particleoptions.power);
        this.AnimationSettings.resetInput(particleoptions);
    }

    checkEnvironmentInput(environmentOptions: environmentInterface) {
        if(environmentOptions.sensitivity !== undefined) this.sensitivityInput.setValue(environmentOptions.sensitivity);
    }

}